// ======================================================================
// File Name       : UserRelationList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from "react";
import { Col, Table, Form } from "react-bootstrap";

const UserRelationList = ({ childUserList }) => {
    if (childUserList.size === 0) {
      return null;
    }
    const userRelationView = childUserList.map((familyInfo, index) =>
      (<tr key={index}>
        <td>{familyInfo.userName}</td>
        <td>{familyInfo.loginId}</td>
      </tr>),
    );
    return (
      <Form.Group className="form-info margin-top-20">
        <Col sm={3} className="margin-bottom-10">閲覧対象ユーザー</Col>
        <Col sm={12}>
          <Table striped hover>
            <thead>
              <tr>
                <th>ユーザー名</th>
                <th>ログインID</th>
              </tr>
            </thead>
            <tbody>
              {userRelationView}
            </tbody>
          </Table>
        </Col>
      </Form.Group>
    );
};

export default UserRelationList;
